import { render, staticRenderFns } from "./ModalImportarCsv.vue?vue&type=template&id=640d81a6&"
import script from "./ModalImportarCsv.vue?vue&type=script&lang=js&"
export * from "./ModalImportarCsv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports